import React from 'react';

import { ReactComponent as DotGreen } from 'assets/pics/DotGreen.svg';
import { ReactComponent as DotGrey } from 'assets/pics/DotGrey.svg';
import { ReactComponent as DotRed } from 'assets/pics/DotRed.svg';
import { ReactComponent as DotYellow } from 'assets/pics/DotYellow.svg';
import PropTypes from 'prop-types';

import { EIV_STATUS_SALES_FORCE, EIV_STATUS_TO_STRING_SALES_FORCE } from 'global/constants';

import './TableStatusCell.sass';

export const TableStatusCell = ({ status }) => {
  const getStatusIcon = () => {
    switch (status) {
      case EIV_STATUS_SALES_FORCE.ACTIVE:
        return <DotGreen />;
      case null:
        return <DotRed />;
      case EIV_STATUS_SALES_FORCE.IN_PROGRESS:
        return <DotYellow />;
      default:
        return <DotGrey />;
    }
  };
  return (
    <div className="data table-status-cell">
      <div className="table-status-cell__status-icon">{getStatusIcon()}</div>
      {EIV_STATUS_TO_STRING_SALES_FORCE[status] || '-'}
    </div>
  );
};

TableStatusCell.propTypes = {
  status: PropTypes.string,
};

TableStatusCell.defaultProps = {
  status: '-',
};
